"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptureOrientationSerializer = void 0;
function vectorToArray(vector) {
    return [vector.x, vector.y, vector.z];
}
function arrayToVector(array) {
    return { x: array[0], y: array[1], z: array[2] };
}
exports.CaptureOrientationSerializer = {
    toOrientation(orientation) {
        if (orientation == null) {
            return undefined;
        }
        return {
            bearing: orientation.bearing,
            pitch: orientation.pitch,
            roll: orientation.roll
        };
    },
    toLegacyOrientation(capture) {
        if (capture.orientation == null) {
            return undefined;
        }
        // Old-style CaptureFileJSONObject where raw data is stored with orientation
        if (capture.orientation['raw'] != null) {
            return capture.orientation;
        }
        if (capture.raw == null || capture.raw.orientation == null) {
            return exports.CaptureOrientationSerializer.toOrientation(capture.orientation);
        }
        const raw = capture.raw.orientation;
        return {
            bearing: capture.orientation.bearing,
            pitch: capture.orientation.pitch,
            roll: capture.orientation.roll,
            magneticnorm: raw.magneticnorm,
            quality: raw.quality,
            declination: raw.declination,
            calibration: raw.calibration,
            raw: {
                accel: vectorToArray(raw.accel),
                gyro: vectorToArray(raw.gyro),
                mag: vectorToArray(raw.mag),
                pitch: raw.pitch,
                roll: raw.roll,
                yaw: raw.yaw
            }
        };
    },
    toRawOrientation(orientation) {
        if (orientation == null) {
            return undefined;
        }
        const result = {
            calibration: orientation.calibration,
            declination: orientation.declination,
            magneticnorm: orientation.magneticnorm,
            quality: orientation.quality
        };
        if (orientation.raw != null) {
            result.accel = arrayToVector(orientation.raw.accel);
            result.gyro = arrayToVector(orientation.raw.gyro);
            result.mag = arrayToVector(orientation.raw.mag);
            result.pitch = orientation.raw.pitch;
            result.roll = orientation.raw.roll;
            result.yaw = orientation.raw.yaw;
        }
        return result;
    }
};
//# sourceMappingURL=capture.orientation.read.js.map